<!--赖传峰-->
<!--2022/6/7-->
<script
  lang="ts"
  setup
>
import {
  authByLocalStorage,
  computed,
  inject,
  reactive,
  useDomain,
} from '#imports'
import { useUserInfo } from '@/store/userInfo'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import { UniqueResourceReport } from '~/components/home/resolve-source/resolve.script'
import useMessage from '~/composables/useMessage'
import { InjectionKey } from '~/types/enum'
import {
  type ReportType,
  reportTypes,
} from './reportTypes'

const { t } = useI18n()
const domain = useDomain()
const props = defineProps<{ resourceUrl?: string }>()
const resourceUrl = computed(() => props.resourceUrl || window.location.href)

const state = reactive<{ type?: ReportType; loading: boolean }>({
  type: undefined,
  loading: false,
})

const visible = defineModel<boolean>('visible')
const showLoginDialog = inject<ShowLoginDialog>(InjectionKey.SHOW_LOGIN_DIALOG)
const report = async () => {
  if (!authByLocalStorage()) return showLoginDialog?.({ afterLogin: report, showHeaderText: false })
  if (await UniqueResourceReport.exist(resourceUrl.value)) {
    return useMessage({
      type: 'warning',
      message: t('report_url_exist'),
    })
  }

  try {
    state.loading = true
    const res = await axios.post(`https://api-feedback.${domain.value}/report`, {
      reportType: state.type,
      resource: resourceUrl.value,
      userInfo: JSON.stringify({ from: 'share', ...(useUserInfo().$state || {}) }),
    }, { headers: { 'Content-Type': 'application/json' } })

    if (res.status === 200 && res.data.code === 0) {
      Object.assign(state, {
        type: undefined,
        loading: false,
      })
      visible.value = false
      UniqueResourceReport.set(resourceUrl.value)
    } else {
      throw Error('Response Error')
    }
  } catch (e) {
    state.loading = false
    console.error(e)
    useMessage({
      type: 'error',
      message: t('failed-to-report'),
      duration: 0,
    })
  }
}

</script>

<template>
  <ElDialog
    v-model="visible"
    :before-close="(done: VoidFunction) => {!state.loading && done()}"
    :title="$t('why-report')"
    append-to-body
    class="report-dialog"
    width="640"
  >
    <ul class="report-type">
      <li
        v-for="type in reportTypes"
        :key="type.value"
        @click="state.type = type.value"
      >
        <span
          :class="state.type === type.value && 'checked'"
          class="pp-checkbox"
        />
        {{ $t(type.title) }}
      </li>
    </ul>
    <template #footer>
      <PPButton
        :disabled="!state.type"
        :loading="state.loading"
        height="36px"
        style="min-width: 120px;"
        type="primary"
        @click="report"
      >
        {{ $t('submit') }}
      </PPButton>
      <ElDivider />
      <div
        class="report-supplement"
        v-html="$t('report-supplement')"
      />
      <div
        class="report-supplement"
        style="margin-top: 10px;"
        v-html="$t('report-supplement-organization')"
      />
    </template>
  </ElDialog>
</template>
<style
  lang="less"
  scoped
>
.report-dialog {
  .report-type {
    li {
      cursor: pointer;
      height: 48px;
      line-height: 22px;
      padding: 5px 0;
      align-items: center;
      display: flex;
      color: var(--color-primary-text);

      .pp-checkbox {
        margin-right: 16px;
      }

      + li {
        border-top: 1px solid #f0f0f0;
      }
    }
  }

  .report-supplement {
    margin-top: 22px;
    width: 100%;
    text-align: left;
    color: var(--color-secondary-text);
    line-height: 20px;
  }
}
</style>
